import { Routes, Route, useNavigate } from "react-router-dom";

import UserRoutesStore from "./UserRoutesStore";
import { IDeviceStateControllerReturn } from "../../../../commonreact/main/services/devicestate/DeviceStateController";
import GlobalLayoutWrapper from "../components/wrapper/GlobalLayoutWrapper";
import PublicLayoutWrapper from "../components/wrapper/publiclayout/PublicLayoutWrapper";
import { IEditBaseControllerReturn } from "../controllers/EditBaseController";
import UserRoutesService from "./UserRoutesService";

interface IProps {
  ebc: IEditBaseControllerReturn;
  dsc: IDeviceStateControllerReturn
}

const UserRoutes: React.FC<IProps> = (props) => {

  const tag = "UserRoutes";
  //console.log(tag+" START");

  const urs = UserRoutesStore;
  const navigate = useNavigate();

  
  {new UserRoutesService(navigate)}
  
  return (
    <Routes> 
      <Route element={<GlobalLayoutWrapper />}>
        <Route element={<PublicLayoutWrapper ebc={props.ebc} dsc={props.dsc} />}>
          {urs.getPublicRoutes()}
          {urs.getDefaultRoute()} 
        </Route>
      </Route>

      <Route element={<GlobalLayoutWrapper />}>
     
      {urs.getHoneyPotRoute()}
      </Route>
    
     
    </Routes>
  );
}

export default UserRoutes;